

































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/products';
import { getSubgroups } from '@/services/groups';
import * as serviceMeasurementUnit from '@/services/measurement-unit';
import IProduct, { ICalorie } from '@/interfaces/product';
import { toNumber } from '@/helpers/toNumber';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ProductMaterial from '@/components/products/product-material.vue';
import ProductModel from '@/models/product-model';
import InputMoney from '@/components/UI/input-money.vue';
import UiFileUpload from '@/components/UI/file-upload.vue';
import { sortKey } from '@/helpers/sort';
import { NEWBORN, ADULT, PEDIATRIC } from '@/settings/consts/patient';
import { PDF_MIME_TYPES } from '@/settings/consts/file-upload';
import {
  MESSAGE_FILE_ERROR_UPLOAD,
  MESSAGE_FILE_SIZE_EXCEEDED,
  MESSAGE_FILE_ERROR_DELETE,
  MESSAGE_PRODUCT_ERROR,
} from '@/settings/consts/messages';
import {
  ERROR_CODE_FILE_SIZE_EXCEEDED,
  ERROR_CODE_PRODUCTS_DUPLICATE,
} from '@/settings/consts/api-error';
import { errorHandling } from '@/helpers/errorHandling';

@Component({
  components: { PermissionAuth, InputMoney, UiFileUpload, ProductMaterial },
})
export default class ProductForm extends BaseComponent {
  @Prop()
  public isEdit: boolean = false;
  @Prop()
  public editItem: any;

  public form: any = {
    valid: false,
    rules: {
      code: [(v) => !!v || 'Coloque um código'],
      name: [(v) => !!v || 'Coloque um nome'],
      subgroup: [(v) => !!v || 'Selecione um subgrupo'],
      use: [(v) => !!v || 'Selecione ao menos um uso'],
      coloracao: [(v) => !!v || 'Selecione a coloração'],
      visibilidade: [(v) => !!v || 'Selecione a visibilidade'],
      measurement_units: [
        (v) =>
          (!!v.length && !!v) || 'Selecione ao menos uma unidade de medida',
      ],
      use_types: [(v) => (!!v && !!v.length) || 'Selecione ao menos um uso'],
      calorieValue: [
        (v) =>
          (!!v && !!toNumber(v)) ||
          'Digite o Kcal/Grama da caloria selecionada.',
      ],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: ProductModel = new ProductModel();
  public maxFileSize: number = 2000;
  public validTypes: string[] = PDF_MIME_TYPES;
  public file: any = null;
  public deleteFile: boolean = false;
  public subgroups: any[] = [];
  public measurementUnits: any = [];
  public useTypesList: any[] = [
    {
      value: ADULT,
      label: 'Adulto',
    },
    {
      value: NEWBORN,
      label: 'Neonato',
    },
    {
      value: PEDIATRIC,
      label: 'Pediátrico',
    },
  ];
  public calories: ICalorie[] = [];

  get useTypes(): string[] {
    const types = [];
    if (!!this.item.usoPacienteAdulto) {
      types.push(ADULT);
    }
    if (!!this.item.usoPacienteNeonato) {
      types.push(NEWBORN);
    }
    if (!!this.item.usoPacientePediatrico) {
      types.push(PEDIATRIC);
    }
    return types;
  }

  set useTypes(val: string[]) {
    const NOT_FOUND = -1;
    this.item.usoPacienteAdulto = val.indexOf(ADULT) !== NOT_FOUND;
    this.item.usoPacienteNeonato = val.indexOf(NEWBORN) !== NOT_FOUND;
    this.item.usoPacientePediatrico = val.indexOf(PEDIATRIC) !== NOT_FOUND;
  }

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.$refs.form.resetValidation();
    this.item = new ProductModel(val);
    this.file = null;
    this.deleteFile = false;

    const hasMlDia = this.item.unidades.find((item) =>
      this.checkSiglaMlDia(item.sigla),
    );
    if (!hasMlDia) {
      const unitMlDia = this.measurementUnits.find((item) =>
        this.checkSiglaMlDia(item.sigla),
      );
      this.item.unidades.push(unitMlDia);
    }

    const uuidv4 = require('uuid/v4');
    this.item.insumos.map((item) => {
      item.id = item.id || uuidv4();
      return item;
    });
    this.getCalories();
  }

  public onRemoveFile() {
    this.deleteFile = true;
    this.item.urlEducativo = null;
  }

  public beforeMount() {
    this.item = new ProductModel();
    this.getSubgroups();
    this.getMeasurementUnits();
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');

    const payload = this.item.toJson();

    const callbackSuccess = () => {
      this.loader.stop();
      this.$emit('save');
    };

    const onError = (error) => {
      this.loader.stop();
      const errorMessages = {
        default: MESSAGE_PRODUCT_ERROR,
        [ERROR_CODE_PRODUCTS_DUPLICATE]:
          !!error && !!error.data ? error.data.message : MESSAGE_PRODUCT_ERROR,
      };
      const message = errorHandling(error, errorMessages);
      this.toast.show(message, 'error');
    };

    const onErrorFile = (error, data) => {
      this.loader.stop();
      this.item = new ProductModel(data);

      const errorMessages = {
        default: MESSAGE_FILE_ERROR_UPLOAD,
      };

      let message;
      if (!!error && error.status === ERROR_CODE_FILE_SIZE_EXCEEDED) {
        message = !!error.data ? error.data : MESSAGE_FILE_SIZE_EXCEEDED;
      } else {
        message = errorHandling(error, errorMessages);
      }

      this.toast.show(message, 'error');
    };

    const onErrorDeleteFile = (error, data) => {
      this.loader.stop();
      this.item = new ProductModel(data);

      const errorMessages = {
        default: MESSAGE_FILE_ERROR_DELETE,
      };
      const message = errorHandling(error, errorMessages);
      this.toast.show(message, 'error');
    };

    if (!this.item.id) {
      service.saveProduct(payload).subscribe((data) => {
        this.$refs.form.resetValidation();
        this.loader.stop();
        this.loader.start('Salvando o arquivo...');

        if (!!this.file) {
          service
            .saveFile(data.id, {
              file: this.file,
            })
            .subscribe(callbackSuccess, (error) => {
              onErrorFile(error, data);
            });
        } else {
          callbackSuccess();
        }
      }, onError);
    } else {
      service.updateProduct(this.item.toJson()).subscribe((data) => {
        this.$refs.form.resetValidation();
        this.loader.stop();
        this.loader.start('Salvando o arquivo...');

        if (!!this.file) {
          service
            .saveFile(data.id, {
              file: this.file,
            })
            .subscribe(callbackSuccess, (error) => {
              onErrorFile(error, data);
            });
        } else if (!!this.deleteFile) {
          service.deleteFile(data.id).subscribe(callbackSuccess, (error) => {
            onErrorDeleteFile(error, data);
          });
        } else {
          this.loader.stop();
          this.$emit('save');
        }
      }, onError);
    }
  }

  public closeForm(): void {
    const closeAction = () => {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  public checkSiglaMlDia(sigla: string): boolean {
    // TODO: change the condition (sigla.toLowerCase() === 'ml/dia') to parameter received from API after parameters screen is done
    return sigla.toLowerCase() === 'ml/dia';
  }

  private getSubgroups(): void {
    getSubgroups().subscribe(
      (data) => {
        const subgroups = [];

        data.reduce((items, item) => {
          if (!!item.grupo) {
            items.push({
              ...item,
              nome: `${item.grupo.nome} / ${item.nome}`,
            });
          }
          return items;
        }, subgroups);

        this.subgroups = subgroups.sort(sortKey('nome'));
      },
      () => {
        this.toast.show('Ocorreu um erro ao carregar os subgrupos.', 'error');
      },
    );
  }

  private getMeasurementUnits() {
    serviceMeasurementUnit.listAll().subscribe((data) => {
      this.measurementUnits = data;
    });
  }

  private getCalories() {
    service.getCalories().subscribe((data) => {
      this.calories = data;
    });
  }

  public disableInput(): boolean {
    return this.isEdit && !this.item.isChangeable;
  }
}
